<template>
  <div class="card-wrapper">
    <div class="transition-wrapper">
      <transition tag="div">
        <div v-if="isEdit" class="box-card-edit" key="edit">
          <div class="header">
            <div class="name">
              <img :src="require('@/assets/img/icon_drug.png')" alt="" />
              {{ `药品${index + 1}` }}
              <transition name="card-fade">
                <span class="error" v-show="saveError">请保存药品信息</span>
              </transition>
            </div>
            <div class="delete">
              <img src="@/assets/img/icon_delete.png" alt="" @click="openRemoveDialog" />
            </div>
          </div>
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-row :gutter="10" type="flex">
              <el-col :span="6">
                <el-form-item label="条形码" prop="barCode">
                  <el-input
                    :disabled="isUpdate"
                    v-model="form.barCode"
                    @change="changeBarcode"
                    placeholder="请输入条形码"
                    :maxlength="20"
                    @focus="focusBarcode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="药品名称" prop="drugName">
                  <el-autocomplete
                    :disabled="isUpdate || hasValidBarcode"
                    popper-class="my-autocomplete"
                    style="width: 100%"
                    v-model="form.drugName"
                    :fetch-suggestions="queryDrugName"
                    :trigger-on-focus="false"
                    valueKey="name"
                    placeholder="请输入药品名/药品首拼搜索"
                    @select="handleSelectDrug"
                    @blur="changeDrug"
                    @focus="focusDrug"
                  >
                    <template #default="{ item }">
                      <div v-if="!item.id" class="item empty">{{ item.empty }}</div>
                      <div class="item" v-else>{{ item.name }}</div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" type="flex">
              <el-col :span="18">
                <el-form-item label="规格" prop="drugSpec">
                  <el-autocomplete
                    :disabled="isUpdate || hasValidBarcode"
                    :value="form.drugSpec"
                    @input="inputSpec"
                    popper-class="my-autocomplete-spec"
                    :fetch-suggestions="querySpec"
                    valueKey="spec"
                    placeholder="示例(0.25g*50粒，0.25g*8片*2板，6g*10袋，3ml:300iu)"
                    @select="handleSelectSpec"
                    @blur="changeSpec"
                    style="width: 96%"
                  >
                    <template #default="{ item }">
                      <div class="item">{{ item.spec }}</div>
                    </template>
                  </el-autocomplete>

                  <el-popover
                    placement="top"
                    width="240"
                    trigger="hover"
                    content="规格一般格式为：数字+单位*数字+单位...，数字+单位为最小单元，中间用*：等符号隔开。"
                  >
                    <i slot="reference" size="28" class="el-icon-question spec-icon"></i>
                  </el-popover>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" type="flex">
              <el-col :span="6">
                <el-form-item label="包装单位" prop="drugUnit">
                  <el-select v-model="form.drugUnit" placeholder="请选择包装单位">
                    <el-option
                      v-for="item in options.units"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用法" prop="drugUsage">
                  <el-cascader
                    @change="changeDrugUsage"
                    :value="form.drugUsage"
                    :options="options.drugUsages"
                    placeholder="请选择用法"
                    :show-all-levels="false"
                    :clearable="true"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" type="flex">
              <el-col :span="6">
                <el-form-item label="使用频次" prop="drugFrequency">
                  <el-select v-model="form.drugFrequency" placeholder="请选择频次">
                    <el-option
                      v-for="item in options.usageFrequencyNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="每次用量" prop="drugDosage">
                  <el-input
                    :value="form.drugDosage"
                    @input="val => change(val, /^\d*(\.?\d{0,3})/, 'drugDosage')"
                    placeholder="请输入药品用量"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用量单位" prop="drugDosageUnit">
                  <el-select v-model="form.drugDosageUnit" placeholder="请选择单位">
                    <el-option
                      v-for="item in options.perUnits"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" type="flex">
              <el-col :span="6">
                <el-form-item label="用药天数" prop="drugTakingDays">
                  <el-input
                    :value="form.drugTakingDays"
                    @input="val => change(val, /^\d*$/, 'drugTakingDays')"
                    placeholder="请输入服用天数"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="drugRemarks" :error="remarkError">
                  <el-input
                    style="width: 100%"
                    v-model="form.drugRemarks"
                    placeholder="请输入备注"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item>
                  <el-button class="btn" type="primary" @click="save">保存</el-button>
                  <el-button class="btn next" @click="add">继续添加</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-else class="box-card-save" key="save">
          <div class="header">
            <div class="name">
              <img :src="require('@/assets/img/icon_drug.png')" alt="" />
              {{ `药品${index + 1}` }}
            </div>
          </div>
          <div class="title">
            <div class="left">
              <span class="name">
                {{ form.drugName }}
              </span>
              <span class="spec">
                {{ form.drugSpec }}
              </span>
            </div>
            <div class="right">
              <img src="@/assets/img/icon_edit.png" alt="" @click="update" />
              &nbsp;&nbsp;
              <img src="@/assets/img/icon_delete.png" alt="" @click="openRemoveDialog" />
            </div>
          </div>
          <div v-if="drugWarn" class="drug-warn">
            {{ drugWarn }}
          </div>
          <div class="content">
            <div class="desc">
              <span class="item">用法：{{ form.drugUsage[1] }}</span>
              <span class="item">用量：{{ form.drugDosage + form.drugDosageUnit }}</span>
              <span class="item">使用频次：{{ form.drugFrequency }}</span>
              <span class="item">包装单位：{{ form.drugUnit }}</span>
            </div>
            <div class="remark">备注：{{ form.drugRemarks || '-' }}</div>
          </div>
          <div class="control-wrapper">
            <div class="control">
              用药天数&nbsp;&nbsp;
              <el-input-number
                v-model="form.drugTakingDays"
                size="medium"
                :min="1"
                :max="120"
                label="label"
                :precision="0"
                @change="changeDrugTakingDays"
              ></el-input-number>
            </div>
            <div class="control">
              数量&nbsp;&nbsp;
              <el-input-number
                v-model="form.drugNum"
                size="medium"
                :min="1"
                :max="limitNum"
                label="label"
                :precision="0"
                @change="changeDrugNum"
              ></el-input-number>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <drug-remove-modal :dialog-visible="removeDialogVisible" @submit="remove" @close="closeRemoveDialog" />
    <drug-remark-modal :dialog-visible="remarkDialogVisible" @submit="addRemark" />

    <el-dialog
      title="提示"
      :visible.sync="specDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="small"
      append-to-body
      center
    >
      <div class="spec-dialog-text">药品规格填写不规范，错误原因：{{ specDialogText }}</div>
      <div class="spec-dialog-text">请参照示例修改。如有疑问，请联系客户经理</div>
      <div class="spec-dialog-text spec-exm-title">药品规格示例</div>
      <div class="spec-dialog-text">
        <div>1、0.25g*50粒</div>
        <div>2、0.25g*8片*2板</div>
        <div>3、6g*10袋</div>
        <div>4、3ml:300iu</div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="specDialogClose">返回修改</el-button>
        <el-button type="primary" plain @click="specDialogIgnore">确认正确，本次忽略</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import find from 'lodash/find';
import debounce from 'lodash/debounce';
import specificationDetection from '@zyf2e/utils/lib/specificationDetection';
import Fetch from '@/api';
import drugRemoveModal from './drugRemoveModal';
import drugRemarkModal from './drugRemarkModal';
import { CARD_MODE, ACTION_TYPE } from '../../constants';
import { INVALID_INPUT_REG } from '@/lib/constant';
import drugValidDialog from './drugValidDialog';

const adaptDrugUsage = drugUsageList => {
  return drugUsageList.reduce((drugUsageObj, drugUsage) => {
    const obj = drugUsage.children.reduce((childrenObj, usage) => {
      childrenObj[usage.value] = drugUsage.value;
      return childrenObj;
    }, {});
    return { ...drugUsageObj, ...obj };
  }, {});
};

export default {
  name: 'drugInfoCard',
  props: {
    info: Object,
    index: Number,
    options: Object,
    drugInfoList: Array,
    drugWarn: String
  },
  data() {
    return {
      form: {
        barCode: '',
        drugName: '',
        drugSpec: '',
        ignoreDrugSpec: false,
        drugUnit: '',
        drugUsage: [],
        drugFrequency: '',
        drugDosage: '',
        drugDosageUnit: '',
        drugTakingDays: '',
        drugRemarks: '',
        drugNum: 1,
        isSingle: 0
      },
      limitNum: 10,
      rules: {
        drugName: [{ required: true, message: '请输入药品通用名', trigger: ['blur', 'change'] }],
        drugSpec: [
          { required: true, message: '请输入药品规格', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (/^[0-9]+$/.test(value)) {
                callback(new Error('规格格式不正确，请重新填写'));
              } else {
                // 输入后选择item也会触发blur 但此时value还是输入的值，没有其他很好的方法，这里只能做延时处理
                setTimeout(() => {
                  if (this.form.drugSpec !== this.oldDrugSpecInBlur) {
                    this.form.ignoreDrugSpec = false;
                  }
                  this.oldDrugSpecInBlur = this.form.drugSpec;
                  if (!this.form.drugSpec || !this.drugProductDTOS.length || this.form.ignoreDrugSpec) {
                    callback();
                  } else {
                    // 判断是否是新增的规格
                    const drugProductDTOS = this.drugProductDTOS.filter(
                      o => o.spec.toLowerCase() === this.form.drugSpec.toLowerCase()
                    );

                    if (drugProductDTOS.length) {
                      callback();
                    } else {
                      Fetch.drug_spec_check({
                        drugName: this.form.drugName,
                        drugSpec: this.form.drugSpec
                      })
                        .then(({ checkResult, checkMessage }) => {
                          if (checkResult) {
                            callback();
                          } else {
                            this.$nextTick(() => {
                              this.specDialogVisible = true;
                              this.specDialogText = checkMessage;
                            });
                            callback(new Error('药品规格填写不规范'));
                          }
                        })
                        .catch(() => callback());
                    }
                  }
                }, 500);
              }
            },
            trigger: ['blur']
          }
        ],
        drugUnit: [{ required: true, message: '请输入药品单位', trigger: 'change' }],
        drugUsage: [{ required: true, message: '请输入药品用法', trigger: ['blur', 'change'] }],
        drugFrequency: [{ required: true, message: '请输入使用频次', trigger: 'change' }],
        drugDosage: [
          { required: true, message: '请输入每次用量', trigger: ['blur', 'change'] },
          {
            validator(rule, value, callback) {
              if (Number(value) > 0) {
                callback();
              } else {
                callback(new Error('每次用量必须大于0'));
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        drugDosageUnit: [{ required: true, message: '请输入用量单位', trigger: 'change' }],
        drugTakingDays: [
          { required: true, message: '请输入服用天数', trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              Fetch.patientApplyMaxDose().then(maxDose => {
                if (Number.isInteger(Number(value)) && Number(value) > 0 && Number(value) <= maxDose) {
                  callback();
                } else {
                  callback(new Error(`请输入1-${maxDose}的正整数`));
                }
              });
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      drugInfo: {},
      drugList: [],
      selectDrugProductDTOS: {},
      drugNameList: [],
      drugProductDTOS: [],
      remarkError: '',
      removeDialogVisible: false,
      remarkDialogVisible: false,
      saveError: false,
      hasValidBarcode: false,
      oldDrugSpecInBlur: '', // 上一次失焦的spec 当新老不用时重置isIgnoreSpec
      specDialogVisible: false,
      specDialogText: ''
    };
  },
  inject: [ACTION_TYPE.UPDATE_DRUG_INFO, ACTION_TYPE.EDIT_DRUG_INFO, ACTION_TYPE.DELETE_DRUG_INFO],
  computed: {
    isEdit() {
      return this.info.mode !== CARD_MODE.SAVE;
    },

    isUpdate() {
      return this.info.mode === CARD_MODE.UPDATE;
    }
  },
  watch: {
    'form.drugName'(val, preVal) {
      const { form } = this;
      val = val.trimEnd();
      preVal = val.trimEnd();
      if (val === '') {
        this.form = Object.assign(form, {
          drugSpec: '',
          ignoreDrugSpec: false,
          drugUnit: '',
          drugUsage: [],
          drugFrequency: '',
          drugDosage: '',
          drugDosageUnit: '',
          drugTakingDays: '',
          drugRemarks: ''
        });
        this.drugProductDTOS = [];
      }
    },
    'form.drugTakingDays'(val) {
      if (this.isEdit) {
        if (val > 7 && !this.form.drugRemarks) {
          this.remarkError = '服用天数大于7天，备注不能为空';
        } else {
          this.remarkError = '';
        }
      } else {
        if (val > 7 && !this.form.drugRemarks) {
          this.remarkDialogVisible = true;
        }
      }
    },
    'form.drugRemarks'(val) {
      if (val !== '' && this.remarkError) {
        this.remarkError = '';
      } else if (val === '' && this.form.drugTakingDays > 7) {
        this.remarkError = '服用天数大于7天，备注不能为空';
      } else {
        this.remarkError = '';
      }
    },
    'form.drugUsage'(val, preVal) {
      // fix cascader form validate bug
      if (val.length !== preVal.length) {
        this.$refs.form.validateField('drugUsage');
      }
    }
  },
  methods: {
    add() {
      this.save(() => this.$emit('add'));
    },
    update() {
      const { info } = this;
      this[ACTION_TYPE.EDIT_DRUG_INFO]({ ...info, mode: CARD_MODE.UPDATE });
    },
    save(callback) {
      this.$refs.form.validate(valid => {
        this.saveError = false;
        if (valid && !this.remarkError) {
          // 避免重复提交
          debounce(_ => this.submit(callback), 300, {
            leading: true,
            trailing: false
          })();
        } else {
          return false;
        }
      });
    },
    async submit(callback) {
      const {
        info,
        drugInfo,
        hasValidBarcode,
        form: {
          barCode,
          drugName,
          drugSpec,
          drugUnit,
          drugDosageUnit,
          drugDosage,
          drugFrequency,
          drugTakingDays,
          drugUsage,
          drugRemarks,
          drugNum
        },
        selectDrugProductDTOS
      } = this;

      const drugBarcodeDTOS = selectDrugProductDTOS.drugBarcodeDTOS;
      /*eslint-disable*/
      const adaptDrugProductDTOS = drugBarcodeDTOS
        ? drugBarcodeDTOS.map(barcodeDTOS => ({
            barcode: barcodeDTOS.barcode,
            enterprise: barcodeDTOS.enterprise
          }))
        : [];

      let validRes = await Fetch.get_drug_machine_result({
        name: drugName,
        spec: drugSpec.trimStart().trimEnd(),
        usage: drugUsage[1],
        unit: drugUnit,
        dose: drugTakingDays,
        usageFrequencyName: drugFrequency,
        perUnit: drugDosageUnit,
        perNum: drugDosage,
        takingDay: drugTakingDays,
        remark: drugRemarks
      });
      if (!validRes.passResult) {
        const ignore = await drugValidDialog.show({ errorReason: validRes.message });
        if (!ignore) return;
      }

      const _drugInfo = {
        ...info,
        drugId: drugInfo.id,
        name: drugName.trimEnd(),
        drugRemarks,
        num: drugNum,
        drugProductDTOS: [
          Object.assign({}, selectDrugProductDTOS, {
            drugId: drugInfo.id,
            spec: drugSpec.trimStart().trimEnd(),
            unit: drugUnit,
            perUnit: drugDosageUnit,
            perNum: drugDosage,
            usageFrequencyName: drugFrequency,
            takingDay: drugTakingDays,
            drugUsage: drugUsage[1],
            drugBarcodeDTOS:
              !hasValidBarcode && barCode !== '' ? [{ barcode: barCode, enterprise: '' }] : adaptDrugProductDTOS
          })
        ],
        from: info.mode,
        mode: CARD_MODE.SAVE
      };

      Telescope.trackEvent({
        trackId: 'zywzpc-add-drug-params',
        custom: { drugId: drugInfo.id, drugInfo: _drugInfo }
      });

      return this[ACTION_TYPE.UPDATE_DRUG_INFO](_drugInfo, callback).then(drugProductDTOS => {
        this.selectDrugProductDTOS = drugProductDTOS;
      });
    },
    remove() {
      const {
        info: { id }
      } = this;
      this[ACTION_TYPE.DELETE_DRUG_INFO](id);
    },
    addRemark(remark) {
      const { form } = this;
      this.form = Object.assign(form, { drugRemarks: remark });
      this.submit();
      this.remarkDialogVisible = false;
    },
    change(val, reg, property) {
      const { form } = this;
      const result = val.match(new RegExp(reg, 'g'));
      val = result ? result[0] : '';
      this.form = Object.assign(form, { [property]: val });
    },
    handleSelectDrug(item) {
      this.checkDrug(item);
    },
    checkDrug(drug) {
      const { form, info } = this;
      if (drug.id) {
        this.drugInfo = drug;

        if (!drug.isIssue) {
          this.form.drugName = '';
          this.drugInfo = {};
          this.$message.error('药品为互联网禁售药品');
        } else {
          // 查询前清空规格列表
          this.drugProductDTOS = [];

          this[ACTION_TYPE.EDIT_DRUG_INFO]({ ...info, isSingle: drug.isSingle });

          Fetch.get_spec(drug.id).then(
            ([{ drugProductDTOS }]) => {
              this.drugProductDTOS = drugProductDTOS;
            },
            _ => {
              // 请求规格失败时，重置规格
              this.drugProductDTOS = [];
            }
          );
          this.form = Object.assign(form, {
            drugSpec: '',
            drugUnit: '',
            drugUsage: [],
            drugFrequency: '',
            drugDosage: '',
            drugDosageUnit: '',
            drugTakingDays: '',
            drugRemarks: ''
          });
        }
      }
    },
    handleSelectSpec(item) {
      const { form, drugInfo } = this;
      const { name, spec, unit, usageFrequencyName, perUnit, perNum, takingDay } = item;
      const drugUsageObj = adaptDrugUsage(this.options.drugUsages);
      this.selectDrugProductDTOS = { ...item };

      // 根据药品名称及规格，数量变化时需要进行限制
      Fetch.get_drug_limit({ drugName: name, drugSpec: spec }).then(res => {
        this.limitNum = res.maxDrugLimit || (res.maxDrugLimit === 0 ? 0 : 10);
      });

      this.form = Object.assign(form, {
        drugName: name,
        drugUnit: unit,
        drugDosageUnit: perUnit,
        drugDosage: perNum,
        drugFrequency: usageFrequencyName,
        drugTakingDays: takingDay,
        drugUsage: drugInfo.drugUsage ? [drugUsageObj[drugInfo.drugUsage], drugInfo.drugUsage] : []
      });
    },
    changeDrug(event) {
      const drug = find(this.drugList, drug => drug.name === event.target.value.trimEnd());
      if (drug) {
        if (this.focusDrugName.trimEnd() !== drug.name) {
          this.checkDrug(drug);
        }
      } else {
        this.form.drugName = '';
      }
    },
    focusDrug(event) {
      this.focusDrugName = event.target.value;
    },
    inputSpec(val) {
      this.form.drugSpec = specificationDetection(val).strReplace;
    },
    changeSpec(event) {
      const val = event.target.value;
      const { selectDrugProductDTOS, form } = this;

      this.form = Object.assign(form, { drugSpec: val });
      const drugProductDTOS = this.drugProductDTOS.filter(o => o.spec.toLowerCase() === val.toLowerCase());

      if (!drugProductDTOS.length) {
        // 新增规格 spuId && companyId 置空
        this.selectDrugProductDTOS = Object.assign({}, selectDrugProductDTOS, { id: null, companyId: null });
      } else {
        this.form.drugName = drugProductDTOS[0].name;
        this.selectDrugProductDTOS = { ...drugProductDTOS[0] };
      }
    },
    changeBarcode(barcode) {
      if (barcode !== '') {
        Fetch.get_drug_name({ barcode }).then(drugList => {
          if (Array.isArray(drugList) && drugList.length > 0) {
            const { form } = this;
            const {
              name,
              drugUsage,
              drugProductDTOS: [item]
            } = drugList[0];
            const drugUsageObj = adaptDrugUsage(this.options.drugUsages);

            this.drugInfo = drugList[0];

            this.hasValidBarcode = true;

            this.selectDrugProductDTOS = item;

            const { spec, unit, perUnit, perNum, usageFrequencyName, takingDay } = item;

            this.form = Object.assign(form, {
              drugName: name,
              drugSpec: spec,
              drugUnit: unit,
              drugDosageUnit: perUnit,
              drugDosage: perNum,
              drugFrequency: usageFrequencyName,
              drugTakingDays: takingDay,
              drugUsage: drugUsage ? [drugUsageObj[drugUsage], drugUsage] : []
            });
          } else {
            this.hasValidBarcode = false;
          }
        });
      } else {
        this.hasValidBarcode = false;
      }
    },
    focusBarcode() {},
    changeDrugNum() {
      const {
        info,
        form: { drugNum }
      } = this;
      if (drugNum === this.limitNum) {
        // 若等于最大值时提示
        this.$message(`数量最多为${this.limitNum}`);
      }
      this[ACTION_TYPE.UPDATE_DRUG_INFO]({ ...info, num: drugNum }, null, false);
    },
    changeDrugTakingDays() {
      const {
        info,
        form: { drugTakingDays }
      } = this;
      this[ACTION_TYPE.UPDATE_DRUG_INFO](
        { ...info, drugProductDTOS: [{ ...info.drugProductDTOS[0], takingDay: drugTakingDays }] },
        null,
        false
      );
    },
    changeDrugUsage(val) {
      this.form.drugUsage = val;
    },
    queryDrugName(drugName, cb) {
      if (drugName !== '' && drugName.length > 1) {
        Fetch.get_drug_name({ name: drugName }).then(drugList => {
          if (Array.isArray(drugList) && drugList.length > 0) {
            this.drugList = drugList;
            cb(drugList);
          } else {
            // eslint-disable-next-line standard/no-callback-literal
            this.drugList = [];
            cb([
              {
                empty: '抱歉，暂未匹配到该药品,紧急添加药品请拨打客服电话400-921-6690，感谢您的理解',
                name: '',
                id: ''
              }
            ]);
          }
        });
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        this.drugList = [];
        cb([
          {
            empty: '抱歉，暂未匹配到该药品,紧急添加药品请拨打客服电话400-921-6690，感谢您的理解',
            name: '',
            id: ''
          }
        ]);
      }
    },
    querySpec(spec, cb) {
      if (this.drugProductDTOS.length > 0) {
        const drugProductDTOS = this.drugProductDTOS.filter(o => o.spec.toLowerCase().indexOf(spec.toLowerCase()) > -1);
        cb(drugProductDTOS);
      } else {
        this.$message.error('药品规格不存在');
        cb(this.drugProductDTOS);
      }
    },
    openRemoveDialog() {
      this.removeDialogVisible = true;
    },
    closeRemoveDialog() {
      this.removeDialogVisible = false;
    },
    specDialogClose() {
      this.specDialogVisible = false;
    },
    specDialogIgnore() {
      this.form.ignoreDrugSpec = true;

      this.specDialogClose();
      this.$nextTick(() => {
        this.$refs.form.validateField('drugSpec');
      });
    }
  },
  components: {
    drugRemoveModal,
    drugRemarkModal
  }
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  margin-bottom: 10px;
  max-height: 1000px;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    color: #242424;
    border-bottom: 1px solid #f2f2f2;

    .name {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
        width: 11px;
        height: 14px;
      }

      .error {
        margin-left: 5px;
        color: #eb3c36;
        font-size: 12px;
      }
    }

    .delete {
      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }

  .box-card-edit {
    padding: 10px;
    width: 100%;
    background: rgb(250, 250, 250);
    border-radius: 8px;

    .btn {
      padding: 12px 25px;

      &.next {
        color: #1e8dff;
        border-color: #1e8dff;
      }
    }

    /deep/ .el-input {
      input {
        padding: 0 30px 0 15px;
      }
    }
  }

  .box-card-save {
    padding: 10px;

    .title {
      display: flex;
      justify-content: space-between;

      .left {
        font-size: 14px;
        font-weight: bolder;
        color: #242424;
      }

      .right {
        img {
          width: 24px;
          height: 24px;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
    }

    .content {
      margin-bottom: 20px;
      font-size: 14px;

      .desc {
        margin-bottom: 11px;

        .item {
          margin-right: 32px;
        }
      }

      .remark {
        font-size: 14px;
        color: #707070;
      }
    }

    .control-wrapper {
      display: flex;
      font-size: 14px;

      .control {
        margin-right: 30px;

        /deep/.el-input-number__decrease {
          background: #fafafa;
          border-right: 1px solid #f2f2f2;
        }

        /deep/.el-input-number__increase {
          background: #fafafa;
          border-left: 1px solid #f2f2f2;
        }
      }
    }
  }

  .card-fade-enter-active,
  .card-fade-leave-active {
    transition: opacity 0.5s;
  }

  .card-fade-enter,
  .card-fade-leave-to {
    opacity: 0;
  }
}

.my-autocomplete {
  .item {
    padding: 0 20px;
    &.empty {
      white-space: break-spaces;
    }
  }
}

.drug-warn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff8200;
  line-height: 36rpx;
  padding: 4px 8px;
  margin-bottom: 8px;
  background: #fff7e6;
  line-height: 36rpx;
}
</style>
<style lang="scss">
.my-autocomplete {
  .item {
    padding: 0 !important;
  }
}

.my-autocomplete-spec {
  width: 300px !important;

  .item {
    word-break: break-all;
    white-space: pre-wrap;
  }
}

.el-cascader-panel {
  .el-cascader-menu__wrap {
    max-height: 204px;
  }
}

.spec-dialog-text {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #242424;
}

.spec-exm-title {
  margin: 12px 0 8px 0;
}
.spec-icon {
  color: #bfbfbf;
  font-size: 16px;
  margin-left: 4px;
}
</style>
